import Role from 'constants/role';
import { useHasRole } from 'hooks/useHasRole';
import React from 'react';
import { ReferenceField, TextField } from 'react-admin';
import VisibilityOffRounded from '@mui/icons-material/VisibilityOffRounded';
import { CopyField } from './CopyField';

function IncomeReferenceField(props) {
  const hasRole = useHasRole();
  if (!hasRole(Role.INCOME_VIEW)) {
    return <VisibilityOffRounded />;
  }
  return (
    <ReferenceField reference="incomes" {...props}>
      <div style={{ display: 'inline-flex', gap: 5 }}>
        <CopyField source="id" label="ID" />
        |
        <TextField source="amount" />
      </div>
    </ReferenceField>
  );
}
IncomeReferenceField.defaultProps = {
  label: 'Income',
  source: 'incomeId',
};

export default IncomeReferenceField;
